export enum TrackingActions {
	ApiResponse = 'api_response',
	Click = 'click',
	Error = 'error',
};
